import turflineSlice from "@turf/line-slice";

export default function lineSlice(feature1, feature2) {
    return turflineSlice(feature1, feature2);
};
